import React, { useState, useEffect } from "react";
import "./countryMaster.css";
import { GetAllCountryDetails, CreateCountryDeatails } from "../../Apis/countryApi";
// import CityMaster from "../CityMaster/cityMaster";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { TableLoader } from "../../Common/ShimmerLoader";

const CountryMaster = () => {
  // const dataFetchURL = "GetCountry";
  const [lgShow, setLgShow] = useState(false);
  const [allcountries, setAllCountries] = useState([]);
  const [newCountryName, setNewCountryName] = useState("");
  const [status, setStatus] = useState("1");
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const headers = ["country_name", "status"];


  // const columns = [
  //   {
  //     name: 'S.No',
  //     selector: (row,index ) => index + 1,
  //     sortable: true,
  //     // format: (row, rowIndex) => rowIndex + 1,
  //   },
  //   {
  //     name: 'Country Name',
  //     selector: (row) => row.country_name,
  //     sortable: true,
  //   },
  //   {
  //     name: 'Status',
  //     selector: (row) => row.status,
  //   },
  //   {
  //     name: 'Action',
  //     cell: (row) => (
  //       <div className="d-flex">
  //       <button
  //                       style={{
  //                         backgroundColor: "#F8CCCD",
  //                         marginRight: "5px",
  //                         borderRadius: "4px",
  //                         border: "1px solid #EC1117",
  //                       }}
  //                       onClick={() => handleEdit}
  //                     >
  //                       <FontAwesomeIcon icon={faEdit} />
  //                     </button>
  //       <button
  //       style={{
  //         backgroundColor: "#FBE6E8",
  //         borderRadius: "4px",
  //         border: "1px solid #EC1117", 
  //       }}
  //     >
  //       View
  //     </button>
  //     </div>
  //     )
  //   },
  // ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await GetAllCountryDetails();
        setAllCountries(data);
        setIsOptionsLoading(false)
      } catch (error) {
      }
    };
    fetchData();
  }, [lgShow]);
  // const addCountry = async () => {
  //   try {
  //     const response = await AddCountry({ country: newCountryName });
  //     const newCountry = await response.json();
  //     setCountries((prevCountries) => [...prevCountries, newCountry]);
  //     localStorage.setItem('countries', JSON.stringify([...countries, newCountry]));
  //     setNewCountryName("");
  //   } catch (error) {
  //   }
  // };

  const addCountry = async () => {
    try {
      const response = await CreateCountryDeatails({ country: newCountryName, status });
      const newCountry = await response.json();
      setAllCountries((prevCountries) => [...prevCountries, newCountry]);
  
      setNewCountryName("");
      setLgShow(false); // Close the modal after adding the country
    } catch (error) {
    }
  };
  

  // const handleAdd = () => {
  //   if (newCountryName.trim() === "") {
  //     alert("Please enter a valid country name");
  //     return;
  //   }
  //   addCountry();
  //    setLgShow(false);
  // };

  return (
    <>
      <div style={{width:"100%"}}>
        <div className="content">
        <div className="page-content">
          <div className="page-header">
          <h4 style={{ display: "flex", marginTop: "30px" }}>
                Countries
              </h4>
              <div className="card">
              <div className="card-body">
              <div
                  className="text-end mb-3"
                >
              {/* <button
                className="btn btn-danger"
                style={{ backgroundColor: "rgb(236, 17, 23)" }}
                onClick={() => setLgShow(true)}
              >
                <i className="fa-solid fa-plus me-1"></i> Add Countries
              </button> */}
              </div>

{/*            
                {isOptionsLoading ? (
                    <div className="row text-center">
                      <div className="col text-center">
                        <Puff
                          visible={true}
                          height="96"
                          width="96"
                          strokeWidth="5"
                          color="red"
                          ariaLabel="rings-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </div>
                    </div>
                  ) : (
                    allcountries && allcountries.length > 0 ? ( */}
                <TableComponent isLoading={isOptionsLoading}
                  DataFetchURL={allcountries}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 2
                    )
                  }
                  />
                   {/* ) : (
                      <div>No data found</div>
                    )
                  )} */}
            </div>
          </div>
        </div>
        
        </div>
            </div>
            </div>
      {/* </div> */}

       {/* <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
        keyboard={false}
      >
        {" "}
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">Add Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">Country Name</label>
                  <input
                    type="text"
                    name="newCountryName"
                    className="form-control"
                    value={newCountryName}
                    onChange={(e) => setNewCountryName(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-4 mt-4 pt-2">
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="status"
                      id="activeRadio"
                      value="1"
                      checked={status === "1"}
                      onChange={(e) => setStatus(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "60px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="status"
                      value="2"
                      id="inactiveRadio"
                      checked={status === "2"}
                      onChange={(e) => setStatus(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="inactiveRadio">
                      Inactive
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={handleClose}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleAdd}
              >
                Create
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal> */}
    </>
  );
};

export default CountryMaster;
